import styled from '@emotion/styled';
import { navigation } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';
import { easeOpacity } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';

export const CustomerContentTab = styled('div', { label: 'CustomerContentTab' })`
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 0%;
    overflow: hidden;
    padding: 0 0 0 10px;
`;

export const CustomerContentWrapper = styled('div', { label: 'CustomerContentWrapper' })`
    flex: 1 1 0%;
    overflow: hidden;
    padding: 0 16px 16px;
`;

export const LhsMenuCustomer = styled('div', { label: 'LhsMenuCustomer' })`
    background-color: ${navigation.bgColor};
    border: 1px solid #ccc;
    flex: 0 0 200px;
    width: 200px;
`;

export const CustomerMainTabWrapper = styled('nav', { label: 'CustomerMainTabWrapper' })`
    background: #fafafa;
    border-bottom: 1px solid #ccc;
    display: flex;
`;

interface MainTabItemType {
    isActive: boolean;
}

export const MainTabItem = styled('button', { label: 'MainTabItem' })<MainTabItemType>`
    background-color: ${({ isActive }): string => isActive ? navigation.bgColorTabActive : 'transparent'};
    border: 0;
    color: ${({ isActive }): string => isActive ? navigation.bgColorTab : navigation.bgColorTabActive};
    cursor: pointer;
    flex: 0 0 50%;
    font-size: 14px;
    font-weight: ${fontWeight.medium};
    line-height: 1.6;
    overflow: hidden;
    padding: 10px;
    position: relative;
    text-overflow: ellipsis;
    transition: color .2s ease;
    z-index: 0;
    &::before {
        background-color: ${navigation.bgColorTabActive};
        bottom: 0;
        content: '';
        left: 0;
        opacity: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: ${easeOpacity};
        z-index: -1;
    }
    &:hover {
        color: ${navigation.txtColorActive};
        &::before {
            opacity: 1;
        }
    }
`;
